import axios from "@axios"
import Vue from 'vue'
import '@/libs/sweet-alerts'
import popups from "./popups"

export default function exportUtils() {

    const { errorToast, successToast} = popups()

    /**
     * Exportar datos vía API
     * @param {string} endpoint 
     * @param {*} data 
     * @param {string} fileName 
     * @param {string} format [ 'PDF', 'XLS', 'CSV' ]
     */
    const exportData = function(endpoint, data, fileName, format){
        if (format.toUpperCase() == "PDF" ) return downloadPDF(endpoint, data, fileName)
        if (format.toUpperCase() == "XLS" ) return downloadXLS(endpoint, data, fileName)
        if (format.toUpperCase() == "CSV" ) return downloadCSV(endpoint, data, fileName)
        if (format.toUpperCase() == "XSIG" ) return downloadXSIG(endpoint, data, fileName)

    }

    /**
     * Creación y descarga de PDF vía API
     * @param {string} endpoint 
     * @param {*} data 
     * @param {string} fileName 
     * @returns boolean
     */
    const downloadPDF = function(endpoint, data, fileName){

        openDownloadingAlert()
        return new Promise(function(resolve, reject) {
            axios.post(endpoint, data, { responseType: 'arraybuffer' }).then(response => {
                let blob = new Blob([response.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = fileName
                link.click()
                closeDownloadingAlert()
                successToast('PDF descargado')

                resolve(true)
            }).catch(error => {
                closeDownloadingAlert()
                errorToast('No se ha podido descargar el PDF')
                reject(false)
            })
        })
    }


    /**
     * Creación y descarga de XLS vía API
     * @param {string} endpoint 
     * @param {*} data 
     * @param {string} fileName 
     * @returns boolean
     */
    const downloadXLS = function(endpoint, params, fileName){

        openDownloadingAlert()
        return new Promise(function(resolve, reject) {
            axios.post(endpoint,  params, { responseType: 'arraybuffer' }).then(response => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', `${fileName}.xls`);
                document.body.appendChild(fileLink);
                fileLink.click();
                closeDownloadingAlert()
                successToast('Excel descargado')

                resolve(true)
            }).catch(error => {
                closeDownloadingAlert()
                errorToast('No se ha podido descargar el Excel')
                reject(false)
            })
        })
    }

    /**
     * Creación y descarga de XSIG vía API
     * @param {string} endpoint 
     * @param {*} data 
     * @param {string} fileName 
     * @returns boolean
     */
    const downloadXSIG= function(endpoint, params, fileName){
        openDownloadingAlert()
        return new Promise(function(resolve, reject) {
            axios.post(endpoint,  params, { responseType: 'arraybuffer' }).then(response => {

                if (response.data.byteLength == 0 ) {
                    throw new Error("Error descargando FacturaE.");
                }


                var fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/xsig' }));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', `${fileName}.xsig`);
                document.body.appendChild(fileLink);
                fileLink.click();
                closeDownloadingAlert()
                successToast('XSIG descargado')

                resolve(true)
            }).catch(error => {
                closeDownloadingAlert()

                errorToast('No se ha podido descargar el XSIG. '+error)
                // reject(false)
            })
        })
    }

    /**
     * Creación y descarga de CSV vía API
     * @param {string} endpoint 
     * @param {*} data 
     * @param {string} fileName 
     * @returns boolean
     */
    const downloadCSV = function(endpoint, data, fileName){

        openDownloadingAlert()

        return new Promise(function(resolve, reject) {
            axios.post(endpoint, data, { responseType: 'arraybuffer' }).then(response => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', `${fileName}.csv`);
                document.body.appendChild(fileLink);
                fileLink.click();
                closeDownloadingAlert()
                successToast('CSV descargado')

                resolve(true)
            }).catch(error => {
                closeDownloadingAlert()
                errorToast('No se ha podido descargar el CSV')
                reject(false)
            })
        })
    }

    /**
     * Descargar una factura en pdf
     * @param {Invoice} invoice 
     * @returns boolean
     */
    const downloadInvoicePDF = function(invoice){
        openDownloadingAlert()

        return new Promise(function(resolve, reject) {
            let fileName = ""
            let id = null
            let endpoint = null
    
            if (invoice.n_receipt){
                fileName = `${invoice.name}.pdf`
                id = invoice.n_receipt
                endpoint = '/download-receipt'
            } 
    
            if (invoice.n_invoice){
                fileName = `${invoice.name}.pdf`
                id = invoice.n_invoice
                endpoint = '/download-invoice'
            } 
    
            if (invoice.n_corrective_receipt){
                fileName = `${invoice.name}.pdf`
                id = invoice.n_corrective_receipt
                endpoint = '/download-receipt'
            } 
    
            if (invoice.n_corrective_invoice){
                fileName = `${invoice.name}.pdf`
                id = invoice.n_corrective_invoice
                endpoint = '/download-invoice'
            } 

    
            axios.post(endpoint, { idRC: invoice.id, id: id }, { responseType: 'arraybuffer' }).then(response => {
                let blob = new Blob([response.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = fileName
                link.click()
    
                closeDownloadingAlert()
                resolve(true)
            }).catch(error => {
                closeDownloadingAlert()
                reject(false)
            })
        })

    }


    const openDownloadingAlert = function() {
          Vue.swal({
            title: 'Descargando...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            onOpen: () => {
              Vue.swal.showLoading();
            }
          })
    }

    const closeDownloadingAlert=function() {
        Vue.swal.close()
    }

    return {
        downloadInvoicePDF,
        downloadPDF,
        downloadXLS,
        downloadCSV,
        exportData,
        openDownloadingAlert,
        closeDownloadingAlert
    }

}